// // Use $ instead of jQuery without replacing global $
(function ($) {
  // var $IE_image = $('img.ie-responsive');
  // objectFitImages($IE_image);

  $(window).on("load", function () {

    $(".info-slider .slider-outer .slider .item").unwrap();
    $(".info-slider .slider-outer .slider .item").unwrap();


    $('.info-slider .slider-outer').each(function () {
      $(this).find('.slider').slick({
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        fade: false,
        infinite: false,
        draggable: false,
        prevArrow: $(this).parents('.info-slider').find('.slide-nav .slide-prev'),
        nextArrow: $(this).parents('.info-slider').find('.slide-nav .slide-next'),
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              draggable: true
            }
          }
        ]
      });
    });


    // $(".info-slider .slider-outer .slider .item .content h5").matchHeight();
    // $(".info-slider .slider-outer .slider .item .content h5, .info-slider .slider-outer .slider .item .content h5").matchHeight();
    limit_lines('body .info-slider .slider-outer .slider .content p', 2);

    setTimeout(function () {
      $(".info-slider .slider-outer .slider .item .content h5").matchHeight();
      $(".info-slider .slider-outer .slider .item .content").matchHeight();
    }, 500);
  });

  $(document).ready(function () {


  });

  $(window).resize(function () {
    setTimeout(function () {
      $(".info-slider .slider-outer .slider .item .content h5").matchHeight();
      $(".info-slider .slider-outer .slider .item .content").matchHeight();
    }, 500);
  });

})(jQuery);